import { AddAdvertisementInterface } from 'constants/interfaces';
import * as Yup from 'yup';

type TranslateFunction = (key: string, params?: Record<string, string>) => string;

export const addAdvertisementInitialValues: AddAdvertisementInterface = {
	image: '',
	title: '',
	description: '',
	link: '',
	days: null,
};

export const addAdvertisementSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		image: Yup.mixed()
			.required(translate('Validation.required', { field: 'Banner' }))
			.test('fileSize', translate('Advertisement.fileSize', { size: '10 MB' }), (value: any) => {
				return value && value.size <= 10000000; // Check for file size <= 10MB
			})
			.test('fileType', translate('Validation.invalidFileType'), (value: any) => {
				return (
					value &&
					['image/jpeg', 'image/jpg', 'image/png', 'image/heic', 'image/heif'].includes(value.type)
				);
			}),
		title: Yup.string()
			.required(translate('Validation.required', { field: 'Title' }))
			.trim(),
		description: Yup.string()
			.required(translate('Validation.required', { field: 'Description' }))
			.min(50, translate('Validation.min', { field: 'Description', number: '50' }))
			.max(1000, translate('Validation.max', { field: 'Description', number: '1000' })),
		link: Yup.string()
			.required(translate('Validation.required', { field: 'Link' }))
			.url(translate('Validation.url', { field: 'Link' }))
			.trim(),
		days: Yup.number()
			.required(translate('Validation.required', { field: 'Days' }))
			.min(1, translate('Validation.minField', { field: 'Days', number: '1' }))
			.max(365, translate('Validation.maxField', { field: 'Days', number: '365' })),
	});
